import {Championships, Events, Superstars, TagTeams, Tournaments} from "./models.js";
import {addSuperstarMatchContracts} from "./superstar.js";
import {addTagTeamMatchContracts} from "./tagTeam.js";

function MatchContract() {

    // Integer
    const bonus = null;

    // Boolean
    const awarded = false;
    const availableForUse = true;

    // String
    const name = null;

    // Foreign keys
    const superstarId = null;
    const tagTeamId = null;
    const eventId = null;
    const championshipId = null;
    const tournamentId = null;

    return {
        bonus,
        awarded,
        availableForUse,
        name,
        superstarId,
        tagTeamId,
        eventId,
        championshipId,
        tournamentId,
    };
}

function getMatchContractSuperstar(matchContract) {
    return Superstars.find({'$loki': matchContract.superstarId})[0];
}

function getMatchContractTagTeam(matchContract) {
    return TagTeams.find({'$loki': matchContract.tagTeamId})[0];
}

function getMatchContractEvent(matchContract) {
    return Events.find({'$loki': matchContract.eventId})[0];
}

function getMatchContractChampionship(matchContract) {
    if (!matchContract.championshipId) {
        return
    }
    return Championships.find({'$loki': matchContract.championshipId})[0];
}

function getMatchContractTournament(matchContract) {
    return Tournaments.find({'$loki': matchContract.tournamentId})[0];
}

function getMatchContractTalent(matchContract) {
    if (matchContract.superstarId) {
        return getMatchContractSuperstar(matchContract)
    }
    else {
        return getMatchContractTagTeam(matchContract)
    }
}

async function addTalentMatchContracts(talent, matchContracts) {
    if (talent.objectName === 'superstar') {
        return addSuperstarMatchContracts(talent, matchContracts)
    }
    else {
        return addTagTeamMatchContracts(talent, matchContracts)
    }
}

export { MatchContract, getMatchContractChampionship, getMatchContractEvent, getMatchContractSuperstar,
    getMatchContractTagTeam, getMatchContractTournament, getMatchContractTalent, addTalentMatchContracts }
